import { Settings } from 'types';
import { mergeData } from 'ui/form-utils';

import { request } from '../config';

export const DEFAULT_SETTINGS: Settings = {
  paymentusSettings: {
    days: 5,
  },
};

export function updateSettings(data: Partial<Settings>): Promise<Settings> {
  return request(
    {
      url: `settings.json`,
      method: 'PATCH',
      data: { settings: data },
    },
    (data) => data.model
  );
}

export function getSettings(signal?: AbortSignal): Promise<Settings> {
  return request(
    {
      url: `settings.json`,
      method: 'GET',
      signal,
    },
    (data) => mergeData(DEFAULT_SETTINGS, data.model || {})
  );
}
